import { EntityTablePage } from "../common/entity/EntityTablePage";
import { DataFormatsTable } from "./Table/DataFormatsTable";

export const DataFormatsTablePage = () => {
  return <EntityTablePage entityTypeId="dataFormats">{(props) => <DataFormatsTable {...props} />}</EntityTablePage>;
};
